import { RapidGameDataServiceAPI } from '@API/gambyt-data-services/rapid-games-api'
import { UnscoredDrawResult } from '@API/game-results/types'
import { DataFetchingState } from '@AppState/types'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export type ViewModeState = {
  fetchState: DataFetchingState
  shouldShowWelcomeDrawer: boolean
  drawResults: ViewModeDrawResult
}

export type ViewModeDrawResult = { [drawNumber: number]: UnscoredDrawResult }

const initialState: ViewModeState = {
  fetchState: DataFetchingState.IDLE,
  shouldShowWelcomeDrawer: false,
  drawResults: {},
}

export const fetchViewModeDrawResults = createAsyncThunk(
  'view-mode/fetchDrawResults',
  async (drawNumber: number) => {
    return await RapidGameDataServiceAPI.fetchResultsByDraw(drawNumber)
  },
)

export const viewModeSlice = createSlice({
  name: 'view-mode',
  initialState,
  reducers: {
    updateShouldShowWelcomeDrawer(state, action) {
      state.shouldShowWelcomeDrawer = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchViewModeDrawResults.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.drawResults[action.payload.drawingNumber] = action.payload
    })
    builder.addCase(fetchViewModeDrawResults.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
    })
    builder.addCase(fetchViewModeDrawResults.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
    })
  },
})

export const ViewModeActions = {
  ...viewModeSlice.actions,
}

export const ViewModeReducer = viewModeSlice.reducer
